export const AccountSummary = ({ name, email }) => {
  return (
    <div className="w-full flex items-center justify-between bg-white shadow-md rounded-2xl p-6 mb-6">
      <div>
        <h1 className="text-xl font-bold">My Account</h1>
        <p className="text-gray-500">Manage your profile and subscription</p>
      </div>
      <div className="flex items-center gap-3">
        <img
          src="https://i.pravatar.cc/80"
          alt="profile"
          className="w-12 h-12 rounded-full"
        />
        <div>
          <p className="font-semibold">{name}</p>
          <p className="text-sm text-gray-500">{email}</p>
        </div>
      </div>
    </div>
  );
};
